query GetArchivedSequenceIds {
    emailSequenceTemplateCollection {
        archivedTemplates {
            id
        }
    }
}
